import { render, staticRenderFns } from "./NewsOfDay.vue?vue&type=template&id=375f36ac&scoped=true"
import script from "./NewsOfDay.vue?vue&type=script&lang=js"
export * from "./NewsOfDay.vue?vue&type=script&lang=js"
import style0 from "./NewsOfDay.vue?vue&type=style&index=0&id=375f36ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375f36ac",
  null
  
)

export default component.exports